
import React from 'react';
import { useParams, useSearchParams, useNavigate, Link } from 'react-router-dom';
import Layout from '@/components/layout/Layout';
import HarvestForm from '@/components/harvests/HarvestForm';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowLeft, CalendarDays, Upload } from 'lucide-react';

const HarvestFormPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const farmId = searchParams.get('farmId');
  const navigate = useNavigate();
  const isEditMode = !!id;

  const handleBackClick = () => {
    if (farmId) {
      navigate(`/farms/${farmId}`);
    } else {
      navigate('/harvests');
    }
  };

  return (
    <Layout>
      <div className="container mx-auto py-8">
        <div className="flex items-center justify-between mb-4">
          <Button 
            variant="outline" 
            size="sm"
            onClick={handleBackClick}
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back
          </Button>
          
          {!farmId && (
            <div className="flex items-center gap-2">
              <Button variant="outline" size="sm" asChild>
                <Link to="/harvest-calendar">
                  <CalendarDays className="mr-2 h-4 w-4" />
                  Calendar View
                </Link>
              </Button>
              <Button variant="outline" size="sm" asChild>
                <Link to="/farms/upload">
                  <Upload className="mr-2 h-4 w-4" />
                  Upload Farms
                </Link>
              </Button>
            </div>
          )}
        </div>
        
        <Card>
          <CardHeader>
            <CardTitle>{isEditMode ? 'Edit Harvest' : 'Add New Harvest'}</CardTitle>
          </CardHeader>
          <CardContent>
            <HarvestForm harvestId={id} farmId={farmId || undefined} />
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default HarvestFormPage;
